import ReactDOM from 'react-dom'
import React from 'react'
import jQuery from 'jquery'

import { createStore } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './reducers';
import EventRender from './containers/event_render'

const event_data = jQuery.parseJSON($('#event-data').html());
const admin_data = jQuery.parseJSON($('#admin-data').html());

const initialState = {
  form: {
    allow_cheque: event_data.allow_cheque,
    complimentary: false,
    tax_name: event_data.tax_name,
    tax_rate: event_data.tax_rate,
    tax: event_data.tax
  },
  admin: admin_data
}

const store = createStore(rootReducer, initialState);

ReactDOM.render(
  <Provider store={store}>
    <EventRender { ...event_data } />
  </Provider>,
  document.getElementById('react-target')
);


// WEBPACK FOOTER //
// ./src/event_render/index.js